/**
 * @description defines routes for the contracts page
 */
import React from 'react';
import PersonnelComparisonTool from '@seccon/pages/personnelComparisonTool';

export default [
  {
    path: 'personnelComparisonTool/:id/index',
    element: (
      <PersonnelComparisonTool />
    )
  }
];
